import { RFWebPermissaoEnum, } from 'app/shared/auth/permissao/cadastro-menu-routes-permission.config';
import { RouteInfo } from 'app/shared/vertical-menu/vertical-menu.metadata';
// import { ACadastroControleAcessoPermissaoEnum } from './../permissao/RFWebCadastroControleAcessoPermissaoEnum';

export const ADMINISTRATIVO_MENU_ROUTES: RouteInfo = {
  path: '', title: 'Administrativo', icon: 'fa fa-shield', id: 16,
  authGuardKey: RFWebPermissaoEnum.rfpAdministrativoMenuAdministrativo, willHaveSub: true,
  class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
  submenu: [
    {
      path: '/administrativo/usuarios-admin', title: 'Usuários Admin', icon: 'fa fa-user', id: 17,
      authGuardKey: RFWebPermissaoEnum.rfpAdministrativoAdminUser,
      class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
    },
    {
      path: '/administrativo/versoes', title: 'Versões', icon: 'fa fa-code-fork', id: 18,
      authGuardKey: RFWebPermissaoEnum.rfpAdministrativoVersion,
      class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
    },
    {
      path: '/administrativo/versoes-android', title: 'Versões Android', icon: 'fa-brands fa-android', id: 19,
      authGuardKey: RFWebPermissaoEnum.rfpAdministrativoAndroidVersion,
      class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
    },
    {
      path: '/administrativo/email', title: 'Emails', icon: 'fa fa-envelope', id: 20,
      authGuardKey: RFWebPermissaoEnum.rfpAdministrativoEmail,
      class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
    },
  ]
}
